import { VariantProps } from 'tailwind-variants';
import { Chip } from '../../atoms/Chip';
import { iIconProps } from '../../atoms/Icon';
import { Typography } from '../../molecules/Typography';
import { BackgroundImage, Band, CardContent, CardStyle } from './variants';
import { ReactNode } from 'react';

type IContentTag = {
  color: string;
  text: string;
  icon?: iIconProps;
};

//TODO: Pensar em um nome melhor
interface IContentListCard extends VariantProps<typeof Band> {
  tags: IContentTag[];
  imageBackground: string;
  text: string;
  subtext?: string;
  hasBand?: boolean;
  band: ReactNode;
  onClick: () => void;
}

export default function ContentListCard({
  tags,
  imageBackground,
  text,
  onClick,
  hasBand = false,
  band,
  color,
  subtext,
}: IContentListCard) {
  const tagShow = () => {
    return (
      <div className='inline-flex w-fit gap-sm px-4 py-5'>
        {tags.map((it, i) => (
          <Chip
            key={i}
            leftIcon={it.icon ? it.icon : undefined}
            variant='negative'
            className={`shadow-level-none px-2 ${it.color}`}
            clamp
          >
            {it.text}
          </Chip>
        ))}
      </div>
    );
  };

  return (
    <article className={CardStyle()} onClick={() => onClick()}>
      <img
        alt={text}
        src={imageBackground ? imageBackground : ''}
        className={BackgroundImage()}
      />
      <div className={CardContent()}>
        <div className='flex h-full flex-col gap-xl'>
          {tags.length > 0 && tagShow()}
          <div className='mt-auto'>
            {hasBand && <div className={Band({ color: color })}>{band}</div>}
            <div
              className={`px-4 py-2 ${subtext ? 'h-32' : 'h-[120px]'} flex flex-col justify-between`}
            >
              <Typography
                size='h4'
                type='title'
                weight='bold'
                className={`text-card-color-default ${subtext ? 'line-clamp-3' : 'line-clamp-4'}`}
              >
                {text}
              </Typography>
              {subtext && (
                <Typography
                  size='small'
                  className='italic text-card-color-default'
                >
                  {subtext}
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
